import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { FormattedMessage, injectIntl } from 'react-intl';

import { Button, TextButton } from '@xingternal/button';
import { IconClock } from '@xingternal/icons';
import { usePopOver } from '@xingternal/pop-over';
import { Headline, Meta, BodyCopy } from '@xingternal/typography';
import { useMediaListener, BREAKPOINTS } from '@xingternal/util';

// Auxiliary declarative error catcher
import ErrorBoundary from '../lib/ErrorBoundary';

import styles from './styles.css';

const Menu = React.lazy(() => import('./MenuLazy'));

const Fencing = () => {
  const popOver = usePopOver();
  const breakpoint = useMediaListener();
  const isHandHeld = () => {
    return breakpoint === BREAKPOINTS.handheld;
  };

  // TODO: handle errors for these kinds of issues. We need some sort of UI
  // const [err, setErr] = React.useState(null);
  const setErr = () => {};

  return (
    <React.Fragment>
      <TextButton
        className={styles.schedulingOpener}
        data-testid={'commbox-scheduling-fencing-button'}
        innerRef={popOver.triggerRef}
        onClick={(event) => {
          popOver.show ? popOver.handleHide() : popOver.handleShow();
          event.preventDefault();
          event.stopPropagation();
        }}
        onMouseOver={() => !isHandHeld() && popOver.handleShow()}
      >
        <IconClock
          width={24}
          height={24}
          className={cx(styles.clockIcon, styles.clockIconFenced)}
        />
        <Meta
          className={cx(
            styles.publishImmediatelyFenced,
            styles.publishImmediatelyFenced
          )}
        >
          <FormattedMessage id="COMMBOX_SCHEDULING_IMMEDIATELY" />
        </Meta>
      </TextButton>
      <ErrorBoundary onError={setErr}>
        <React.Suspense fallback={<div></div>}>
          {popOver.show && (
            <Menu
              className={cx(isHandHeld() ? styles.menuMobile : styles.menu)}
              dimmerTitle="close menu"
              data-testid={'commbox-scheduling-fencing-menu'}
              onMouseOver={() => {
                !isHandHeld() && popOver.handleShow();
              }}
              onOutsideClick={() => popOver.handleHide()}
              show={popOver.show}
              triggerRef={popOver.triggerRef}
            >
              <Headline size="xlarge">
                <FormattedMessage id="COMMBOX_SCHEDULING_FENCING_HEADLINE" />
              </Headline>
              <BodyCopy>
                <FormattedMessage id="COMMBOX_SCHEDULING_FENCING_SUBLINE" />
              </BodyCopy>
              <Button
                data-testid={'commbox-scheduling-upsell-button'}
                href={
                  'https://recruiting.xing.com/de/produkte-loesungen/produkte/employer-branding-profil?sc_o=entity_page_companies_start_upsell_commbox_tooltip'
                }
                rel="noreferrer noopener nofollow"
                target="_blank"
                variant="proBusiness"
              >
                <FormattedMessage id="COMMBOX_SCHEDULING_FENCING_CTA_BUTTON" />
              </Button>
            </Menu>
          )}
        </React.Suspense>
      </ErrorBoundary>
    </React.Fragment>
  );
};

Fencing.propTypes = {
  intl: PropTypes.object.isRequired,
};

const DateTimePickerFencing = injectIntl(Fencing);

export { DateTimePickerFencing };
